import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/BlogUsecasesBlock/BlogUsecasesBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/CardsCarouselBlock/CardsCarouselBlockViewer/CardsCarouselBlockViewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DigitalTwinSearch"] */ "/opt/render/project/src/apps/web/src/components/blocks/DigitalTwinBlock/DigitalTwinSearch/DigitalTwinSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/HtmlContentBlock/HtmlContentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/ImageCarouselBlock/ImageCarouselBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/PagelinksProductsBlock/PagelinksProductsListItem/PagelinksProductsListItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/ProductsCarouselBlock/ProductsCarouselCard/ProductsCarouselCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/ReassuranceTestimonialsBlock/ReassuranceTestimonialsCarousel/ReassuranceTestimonialsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/ReassuranceTestimonialsBlock/ReassuranceTestimonialsProductCarousel/ReassuranceTestimonialsProductCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/SelectBlock/SelectBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/blocks/VideoBlock/VideoBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticlePreview"] */ "/opt/render/project/src/apps/web/src/components/Blog/ArticlePreview/ArticlePreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/ColorProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/DatoLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/DatoLink/InternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/DatoLink/ObviousLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/web/src/components/Layout/HeroWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/react-datocms/dist/esm/Image/index.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Drawer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Select.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/SelectButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/molecules/ClippedImage.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/molecules/FilterSelect.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/molecules/NavigationMenu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/molecules/ScrollSpy.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/molecules/Toaster.tsx");
